import { render } from "./Schools.vue?vue&type=template&id=4f7eae0c&scoped=true"
import script from "./Schools.vue?vue&type=script&lang=js"
export * from "./Schools.vue?vue&type=script&lang=js"

import "./Schools.vue?vue&type=style&index=0&id=4f7eae0c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src861020327/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7eae0c"]])

export default __exports__